import { Box, InputLabel, TextField, Typography } from "@mui/material";
import MainModal from "components/MainModal";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import React, { useState } from "react";
import { IAddMainItemModal } from "../RCAFishboneDiagramInterfaces";
import { useTranslation } from "react-i18next";

const AddNewMainItemModal = ({ open, onClose, category, onSaveNewMainItem, disabled }: IAddMainItemModal) => {
    const mainClasses = useRCAMainStyles();
    const { t } = useTranslation();
    const [addNewItemTextDescription, setAddNewItemTextDescription] = useState<string | null | undefined>("");

    const handleOnClose = () => {
        setAddNewItemTextDescription("");
        onClose();
    };

    return (
        <MainModal
            isOpen={open}
            onClose={handleOnClose}
            title={t("rca.rca_library.rca_detail.fishbone_diagram.main_item", {
                category: category?.name,
            })}
            showCloseButton
            customModalStyles={{ width: 600 }}
            onOkButtonClick={() => {
                onSaveNewMainItem(category!, addNewItemTextDescription!);
                handleOnClose();
            }}
            okButton={t("rca.rca_library.rca_detail.fishbone_diagram.save")}
            disableOkButton={!addNewItemTextDescription?.trim() || disabled}
        >
            <Box className={`${mainClasses.contentFormBox} ${mainClasses.contentCardContent}`}>
                <InputLabel id="outlined-actionPlanDescription-label">
                    <Typography variant="subtitle2" className={mainClasses.contentFormLabelMaxWidth}>
                        {t("rca.rca_library.rca_detail.fishbone_diagram.main_item_title")}
                    </Typography>
                </InputLabel>
                <TextField
                    fullWidth
                    className={mainClasses.contentFormMultitextField}
                    multiline
                    rows={3}
                    type="text"
                    placeholder={t("rca.rca_library.rca_detail.fishbone_diagram.main_item_placeholder")}
                    variant="outlined"
                    value={addNewItemTextDescription}
                    onChange={(e) => setAddNewItemTextDescription(e.target.value)}
                />
            </Box>
        </MainModal>
    );
};

export default AddNewMainItemModal;
